import { SVGProps } from 'react';

interface Props {
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
  muted?: boolean;
}

const Discovery = ({ props, size = 16, muted = false }: Props) => {
  const dark = muted ? '#5d5d5d' : '#1742b6';
  const light = muted ? '#6d6d6d' : '#4190ff';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 13 16"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path fill={dark} d="M5 0a8 8 0 1 1 0 16z" />
      <path fill={light} d="M10 8A5 5 0 1 1 0 8a5 5 0 0 1 10 0" />
    </svg>
  );
};

export default Discovery;
